import React from "react";
import BottomNav from "./BottomNav";


const Footer = () => (
  <div className="pt-5 md:hidden">
    <BottomNav></BottomNav>
  </div>
);

export default Footer;
